<template>
  <v-container fluid class="px-0">
    <div class="purchaseorder-page">
      <v-row>
        <v-col cols="12" md="12">
          <v-card>
            <v-card-text>
              <v-row class="ma-1">
                <v-col cols="12" md="4">
                  <p class="rhead">
                    {{ initvalue.purchaseordertype }} {{ initvalue.purchaseordernum }}
                  </p>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="2" align="right">
                  <v-btn @click="Done" color="primary" text>
                <v-icon class="mr-2">mdi-check</v-icon>
                Done
                </v-btn>
                </v-col>
              </v-row>
              <v-row class="ma-1">
                <v-col cols="12" md="4">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Num</td>
                        <td>{{ initvalue.purchaseordernum }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Date</td>
                        <td>{{ new Date(initvalue.purchaseorderdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Name</td>
                        <td>{{ initvalue.purchaseordername }}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
                <v-col cols="12" md="4">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Address</td>
                        <td class="tcell">{{ initvalue.purchaseorderaddress }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Phone</td>
                        <td>{{ initvalue.purchaseorderphone }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Mobile</td>
                        <td>{{ initvalue.purchaseorderphone }}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
                <v-col cols="12" md="4">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Note</td>
                        <td class="tcell">{{ initvalue.purchaseordernote }}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" cols="12" class="pt-0 pt-sm-3">
          <v-row>
            <v-col cols="12">
              <v-card class="folder-card ma-1" min-height="282">
                <v-card-text class="pa-5 pt-0">

                  <v-tabs color="secondary">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="1"
                      :href="'#tab-items'"
                    >
                      Items
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="2"
                      :href="'#tab-receipts'"
                    >
                      Receiving
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="3"
                      :href="'#tab-costs'"
                    >
                      Usage
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="4"
                      :href="'#tab-files'"
                    >
                      Files
                    </v-tab>
                    <v-tab-item
                      :key="1"
                      :value="'tab-items'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            loading-text="Loading... Please wait"
                            :loading="isReceiving"
                            item-key="_id"
                            sort-by="transdate"
                            :footer-props="footer"
                            :headers="header_item"
                            :items="transactions"
                            :items-per-page="itemPerPage">
                            <template v-slot:item.itemimage="{ item }">
                              <v-img
                              v-if="item.itemimage" 
                              v-bind:src="item.itemimage"
                              max-height="100"
                              max-width="100"
                            ></v-img>
                            </template>
                            <template v-slot:item.transdate="{ item }">
                              {{ item.transdate!=null ? new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
                            </template>
                            <template v-slot:item.itemamount="{ item }">
                              <p class="two-line">{{ item.itemamount.toFixed(2) }}</p>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item
                      :key="2"
                      :value="'tab-receipts'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            loading-text="Loading... Please wait"
                            item-key="_id"
                            sort-by="transdate"
                            :footer-props="footer"
                            :headers="header_receive"
                            :items="receipts"
                            :items-per-page="itemPerPage">
                            <template v-slot:item.itemimage="{ item }">
                              <v-img
                              v-if="item.itemimage" 
                              v-bind:src="item.itemimage"
                              max-height="100"
                              max-width="100"
                            ></v-img>
                            </template>
                            <template v-slot:item.receiveQty="{ item }">
                              <p v-if="item.receiveQty!=null" class="two-line">{{ item.receiveQty.toFixed(2) }}</p>
                            </template>
                            <template v-slot:item.useQty="{ item }">
                              <p v-if="item.useQty!=null" class="two-line">{{ item.useQty.toFixed(2) }}</p>
                            </template>
                            <template v-slot:item.transdate="{ item }">
                              {{ item.transdate!=null ? new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item
                      :key="3"
                      :value="'tab-costs'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            loading-text="Loading... Please wait"
                            item-key="_id"
                            sort-by="transdate"
                            :footer-props="footer"
                            :headers="header_cost"
                            :items="costs"
                            :items-per-page="itemPerPage">
                            <template v-slot:item.transdate="{ item }">
                              {{ item.transdate!=null ? new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
                            </template>
                            <template v-slot:item.itemamount="{ item }">
                              <p class="two-line">{{ item.itemamount.toFixed(2) }}</p>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item :value="'tab-files'" :key="4">
                      <FileView :id="initvalue._id" :route="`purchaseorder`" :files="files" :data="initvalue"/>
                    </v-tab-item>  
                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import FileView from "@/pages/File/Components/FileView.vue";

export default {
  name: "PurchaseOrderView",
  components: {
    FileView
  },
  data() {
    return {
      header_item: [
        { text: 'Image', value: 'itemimage', width: '10%' },
        { text: 'Name', value: 'itemname' },
        { text: 'Qty', value: 'itemquantity', width: '5%'},
        { text: '', value: 'unit', width: '5%' },
        { text: 'Prc', value: 'itemcost', width: '10%'},
        { text: 'Amount', value: 'itemamount', width: '10%'},
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      header_receive: [
        { text: 'Image', value: 'itemimage', width: '10%' },
        { text: 'Name', value: 'itemname' },
        { text: 'Receive Qty', value: 'receiveQty', width: '12%'},
        { text: 'Used Qty', value: 'useQty', width: '12%'},
        { text: 'Cost', value: 'itemcost', width: '10%'},
      ],
      header_cost: [
        { text: 'transdate', value: 'transdate', width: '10%' },
        { text: 'Name', value: 'itemname' },
        { text: 'SO Ref', value: 'sorefnum', width: '10%' },
        { text: 'PR Ref', value: 'prrefnum', width: '10%' },
        { text: 'Cost ', value: 'itemcost', width: '10%'},
        { text: 'Quantity ', value: 'itemquantity', width: '10%' },
        { text: 'Amount', value: 'itemamount', width: '10%' },
      ],
      initvalue: {},
      transactions: [],
      costs: [],
      files: [],
      receipts: [],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
      image: null,
    };
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('Employee', ['employees']),
    ...mapState('PurchaseOrder', ['isReceiving']),
  },
  methods: {
    ...mapActions('Account', ["getAccountsRequest"]),
    ...mapActions('Employee', ["getEmployeesRequest"]),
    ...mapActions('PurchaseOrder', ["getPurchaseOrderRequest"]),
    Done(){
      this.$router.push({ name: 'PurchaseOrderList' });
    },
  },
  async created() {
    this.initvalue = this.$route.params;    
    if (!this.initvalue._id) this.$router.push({ name: "PurchaseOrderList" });
    let result = await this.getPurchaseOrderRequest(this.initvalue._id);
    this.transactions = Object.assign([], result.transactions);
    this.costs = Object.assign([], result.costs);
    this.receipts = Object.assign([], result.receipts);
    this.files = Object.assign([], result.files);

    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.employees.length==0) await this.getEmployeesRequest();
  },
};
</script>

<style src="./View.scss" lang="scss"/>
